<template>
  <div class="introduct-box " id="jzjianjie">
    <div class="introduct-top inner">
      <div class="introduct-imgs">
        <div class="introduct-images">
          <img src="../../assets/img/22_1.jpg" alt=""/>
        </div>
        <div class="introduct-video" >
          <figure><img src="../../assets/img/22_2.png" alt=""/></figure>
          <video style="display: none"
            ref="video"
            preload="auto"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x-webkit-airplay="allow"
            webkit-playsinline
            playsinline
            muted
            :src="video"
            :class="{'show': showStatus}"
            controls
          >
            <source :src="video" type="video/mp4" />
          </video>
          <!-- <span  v-show="!showStatus" class="introbtn" @click="plays"></span> -->
        </div>
      </div>
      <div class="introduct-info">
        <strong>{{Introduct.ename}}</strong>
        <div class="introductfix" v-html="Introduct.content"></div>
      </div>
    </div>
    <div class="introduct-data inner slideList" v-animate-onscroll="'animateMove'">
      <div class="introduct-data-item">
        <router-link :to="`/company?layIndex=0`">
           <div class="dits">
            <i></i>
          </div>
          <div class="introduct-info-box">
            <strong><b>1</b>家</strong>
            <p>牵头单位</p>
          </div>
        </router-link>
      </div>
      <div class="introduct-data-item">
        <router-link :to="`/company?layIndex=1`">
          <div class="dits">
            <i></i>
          </div>
          <div class="introduct-info-box">
            <strong><b>10</b>家</strong>
            <p>10家股东</p>
          </div>
        </router-link>
      </div>
      <div class="introduct-data-item">
        <router-link :to="`/company?layIndex=2`">
          <div class="dits">
            <i></i>
          </div>
          <div class="introduct-info-box">
            <strong><b>20</b>家</strong>
            <p>共建单位</p>
          </div>
        </router-link>
      </div>
      <div class="introduct-data-item">
        <a href="javascript:;">
          <div class="dits">
            <i></i>
          </div>
          <div class="introduct-info-box">
            <strong><b>5</b>亿</strong>
            <p>注册资本</p>
          </div>
        </a>
      </div>
      <div class="introduct-data-item">
        <a href="javascript:;">
          <div class="dits">
            <i></i>
          </div>
          <div class="introduct-info-box">
            <strong><b>10</b>亿</strong>
            <p>创新基金</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      Introduct: {},
      video: require('@/assets/images/video.mp4'),
      showStatus: false
    }
  },
  methods: {
    async getData () {
      const { data: res } = await this.$http.get('/fdata/page_show?catid=84')
      if (res.code === 1) {
        this.Introduct = res.data
        console.log(this.Introduct)
      }
    },
    plays () {
      this.showStatus = true
      this.$refs.video.play()
      this.$refs.video.addEventListener("ended", () => {
        this.showStatus = false
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import url("@/assets/css/about/index.less");
</style>
